import { Box, IconButton, Typography, Collapse, useTheme } from '@mui/material';
import { useState } from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const CollapsableWrapper = ({
    children,
    title = 'Filtros',
    defaultOpen = false,
    extraButton = null,
    mb = 2,
    headerBackgroundColor = 'background.darkCard',
    headerColor = 'text.primary',
    fontSizeTitle = 16,
    colorIcon = 'text.primary',
    fontWeightTitle = 400,
    ...props
}) => {
    const theme = useTheme();
    const [open, setOpen] = useState(defaultOpen);
    const [isOpenedAtLeastOnce, setIsOpenedAtLeastOnce] = useState(defaultOpen);

    const handleToggle = () => {
        setOpen((prev) => {
            const newOpen = !prev;
            if (newOpen && !isOpenedAtLeastOnce) {
                setIsOpenedAtLeastOnce(true);
            }
            return newOpen;
        });
    };

    return (
        <Box
            sx={{
                border: `1px solid ${theme.palette.border.main}`,
                borderRadius: 0.5,
                position: 'relative',
                '&:before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '3px',
                    background: `linear-gradient(90deg, ${theme.palette.border.accent2} 0%, ${theme.palette.border.accent2}40 60%, transparent 100%)`,
                    borderTopLeftRadius: '4px',
                    borderTopRightRadius: '4px',
                    pointerEvents: 'none',
                    zIndex: 1,
                },
            }}
            {...props}
            mb={mb}
        >
            <Box
                display="flex"
                alignItems="center"
                height={34}
                pl={1}
                bgcolor={headerBackgroundColor}
                onClick={handleToggle}
                sx={{ '&:hover': { cursor: 'pointer', opacity: 0.9 } }}
            >
                <Typography
                    variant="body2"
                    flexGrow={1}
                    color={headerColor}
                    sx={{ fontSize: fontSizeTitle, fontWeight: fontWeightTitle }}
                >
                    {title}
                </Typography>
                <Box>
                    {extraButton}
                    <IconButton size="small" aria-label="Expandir o colapsar filtros">
                        {open ? (
                            <ExpandLessIcon fontSize="small" sx={{ color: colorIcon }} />
                        ) : (
                            <ExpandMoreIcon fontSize="small" sx={{ color: colorIcon }} />
                        )}
                    </IconButton>
                </Box>
            </Box>
            <Collapse in={open}>{isOpenedAtLeastOnce && <Box p={1}>{children}</Box>}</Collapse>
        </Box>
    );
};

export default CollapsableWrapper;
